export function scrollWindowToTop() {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }

  const html = document.documentElement
  const body = document.body
  const previousHtmlBehavior = html.style.scrollBehavior
  const previousBodyBehavior = body.style.scrollBehavior

  html.style.scrollBehavior = 'auto'
  body.style.scrollBehavior = 'auto'

  window.scrollTo(0, 0)
  html.scrollTop = 0
  body.scrollTop = 0

  html.style.scrollBehavior = previousHtmlBehavior
  body.style.scrollBehavior = previousBodyBehavior
}

export function scrollToHashTarget(hash, behavior = 'auto') {
  const id = hash.replace(/^#/, '')
  if (!id) {
    scrollWindowToTop()
    return false
  }

  const el = document.getElementById(id)
  if (!el) return false

  el.scrollIntoView({ behavior, block: 'start' })
  return true
}

export function scheduleScrollReset({ hash, delays = [0, 120, 350, 700] } = {}) {
  delays.forEach((delay) => {
    window.setTimeout(() => {
      if (hash) {
        if (!scrollToHashTarget(hash)) {
          scrollWindowToTop()
        }
      } else {
        scrollWindowToTop()
      }
    }, delay)
  })
}
